import React, { useState, useEffect, } from 'react'

import { Modal } from 'react-bootstrap';
import HtmlParser from 'react-html-parser';

import axios from 'axios';

import moment from 'moment-timezone';
import 'react-tempusdominus-bootstrap';

import {
    responseGet, globalSettings, styles, validateEmail, validatePhoneNumber, dateTimeFormatGlobalSet, sendMessageCloseCurrentWindowAsync, languageObjGet, isUndNullEmp, awaitDelay
} from '../../helpers/settings';
import { supplierProcessButtonsGetAsync } from '../../controllers/suppliers/suppliers';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { supplierModelGet } from '../../models/expenses/suppliers';
import { countryModelGet } from '../../models/countries/country';

const currentMethod = 'SupplierAddEditDetails';

const { app, images, labels, messages, react, } = globalSettings;
const { backend, } = app;

export default function SupplierAddEditDetails({
    $ = {},
    auth = {},
    supplier = supplierModelGet({}),
    setSupplier = () => { },
    dtSuppliersId = '',
    dtSuppliersRowIndex = 0,
    countries = [countryModelGet({})],
    showModal = false,
    setShowModal = () => { },
    processType = 0,
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const supplierDateId = 'supplierDate';
    const [descriptionError, setDescriptionError] = useState('');
    const [rifError, setRifError] = useState('');
    const [nitError, setNitError] = useState('');
    const [dateError, setDateError] = useState('');
    const [addressError, setAddressError] = useState('');
    const [countryError, setCountryError] = useState('');
    const [cityError, setCityError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState('');
    const [contactDescriptionError, setContactDescriptionError] = useState('');
    const [contactPhoneNumberError, setContactPhoneNumberError] = useState('');
    const controls = {
        buttons: {
            save: {
                id: 'btnModalSupplierEditDetailSave',
                className: 'btn btn-outline-warning mx-1',
            },
            back: {
                id: 'btnModalSupplierEditDetailBack',
                className: 'btn btn-outline-success',
            },
            close: {
                id: 'btnModalSupplierEditDetailClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        inputs: {
            description: {
                id: 'inputModalSupplierEditDetailDescription',
                className: 'form-control',
            },
            rif: {
                id: 'inputModalSupplierEditDetailRif',
                className: 'form-control',
            },
            nit: {
                id: 'inputModalSupplierEditDetailNit',
                className: 'form-control',
            },
            date: {
                id: 'inputModalSupplierEditDetailDate',
                className: 'form-control text-black bg-transparent datetimepicker-input',
            },
            address: {
                id: 'inputModalSupplierEditDetailAddress',
                className: 'form-control',
            },
            city: {
                id: 'inputModalSupplierEditDetailCity',
                className: 'form-control',
            },
            mail: {
                id: 'inputModalSupplierEditDetailMail',
                className: 'form-control',
            },
            phoneNumber: {
                id: 'inputModalSupplierEditDetailPhoneNumber',
                className: 'form-control',
            },
            contactName: {
                id: 'inputModalSupplierEditDetailContactName',
                className: 'form-control',
            },
            contactPhoneNumber: {
                id: 'inputModalSupplierEditDetailContactPhoneNumber',
                className: 'form-control',
            },
        },
        checkboxs: {
            isNational: {
                id: 'chkModalSupplierEditDetailIsNational',
                className: 'icheck-primary d-inline',
            },
        },
        dataTables: {
            // conceptsFind: {
            //     buttons: {
            //         // create: {
            //         //     className: 'btn btn-outline-success float-right btn-sm',
            //         //     id: 'btnDtExpenseConceptsCreate',
            //         // },
            //     },
            //     icons: {
            //         // create: {
            //         //     id: 'iconDtExpenseConceptsCreate',
            //         //     className: globalSettings?.icons?.plusCircle,
            //         // },
            //     },
            //     inputs: {
            //         // search: {
            //         //     id: `${dtConceptsFindId}_filter input`,
            //         //     className: '',
            //         // },
            //     },
            //     selects: {
            //         // entries: {
            //         //     id: `${dtConceptsFindId}_length select`,
            //         //     className: '',
            //         // },
            //     },
            //     spinners: {
            //         // create: {
            //         //     id: 'spDtExpenseConceptsCreate',
            //         //     className: '',
            //         // },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoModalSupplierEditDetailSave',
                className: globalSettings?.icons?.save,
            },
            back: {
                id: 'icoModalSupplierEditDetailBack',
                className: globalSettings?.icons?.arrowCircleLeft,
            },
        },
        selects: {
            countries: {
                id: 'chkModalSupplierEditDetailCountries',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spModalSupplierEditDetailSave',
                className: '',
            },
            back: {
                id: 'spModalSupplierEditDetailBack',
                className: '',
            },
        },
    };
    //#endregion variables

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region ateTime set
            response = await dateInControlSetAsync({
                date: new Date(),
                supplierDate: processType !== 0 ? supplier?.date : '',
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion ateTime set
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dateInControlSetAsync = async ({ date = new Date(), supplierDate = '', subMethod = '', }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj.date = '';
            //const dateTimeObj?.format = react?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = react?.tempusDominus?.format?.date?.DDMMYYYY;
            //#endregion old code
            const dateTimeObj = {
                date: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: supplierDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: supplierDate,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: react?.tempusDominus?.icons,
                buttons: react?.tempusDominus?.buttons,
                tooltips: react?.tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            $(`#${supplierDateId}`)?.datetimepicker({
                date: moment(`${dateTimeObj.date}`, dateTimeObj?.formatTwo),
                default: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataSupplierSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataSupplierSetAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateObj = {
                date: $(`#${supplierDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            supplier.date = !isUndNullEmp({ data: dateObj.date, subMethod: currentMethod, })?.result ? dateObj?.date : supplier?.date;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const supplierAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'supplierAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let supplierLocal = supplierModelGet({});
            //#endregion variables

            //#region errors default set
            response = await errorsDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion errors default set

            //#region supplier data set
            response = await dataSupplierSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion supplier data set

            //#region form data validate
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data validate

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create supplier
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj = {
                supplier: supplier,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlSuppliers}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            supplierLocal = response?.result || supplierModelGet({});
            setSupplier(supplierLocal);
            //#endregion create supplier

            //#region update dataTable
            response = await supplierProcessButtonsGetAsync({
                supplier: supplierLocal,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            $(`#${dtSuppliersId}`)?.DataTable()?.row?.add(response?.result)?.draw(true);

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            //#endregion update dataTable

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const supplierEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'supplierEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let supplierLocal = supplierModelGet({});
            //#endregion variables

            //#region errors default set
            response = await errorsDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion errors default set

            //#region supplier data set
            response = await dataSupplierSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion supplier data set

            //#region form data validate
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion form data validate

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region update supplier
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj = {
                supplier: supplier,
                languageId: languageObj?.id,
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlSuppliers}/${supplier?.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            supplierLocal = response?.result;
            setSupplier(supplierLocal);
            //#endregion update supplier

            //#region update dataTable
            response = await supplierProcessButtonsGetAsync({
                supplier: supplierLocal,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return response;
            }

            $(`#${dtSuppliersId}`)?.DataTable()?.row(dtSuppliersRowIndex).data(response?.result)?.draw(true);

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });
            //#endregion update dataTable

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await errorsDefaultSetAsync({ subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            }
            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            const dataObj = {
                date: $(`#${controls?.inputs?.date?.id}`).val(),
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: supplier?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: supplier?.rif, subMethod: currentMethod, })?.result) {
                setRifError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataObj?.date, subMethod: currentMethod, })?.result) {
                setDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: supplier?.address, subMethod: currentMethod, })?.result) {
                setAddressError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: supplier?.countryId, subMethod: currentMethod, })?.result) {
                setCountryError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: supplier?.city, subMethod: currentMethod, })?.result) {
                setCityError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: supplier?.email, subMethod: currentMethod, })?.result && !validateEmail({ email: supplier?.email, })) {
                setEmailError(messages?.youMustEnterValidEmail?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: supplier?.phoneNumber, subMethod: currentMethod, })?.result && !validatePhoneNumber({ phoneNumber: supplier?.phoneNumber, })) {
                setPhoneNumberError(messages?.youMustEnterValidPhoneNumber?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (!isUndNullEmp({ data: supplier?.contactPhoneNumber, subMethod: currentMethod, })?.result && !validatePhoneNumber({ phoneNumber: supplier?.contactPhoneNumber, })) {
                setContactPhoneNumberError(messages?.youMustEnterValidPhoneNumber?.[languageObj?.id]);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errorsDefaultSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'errorsDefaultSetAsync';
        let response = responseGet();
        try {
            setDescriptionError('');
            setRifError('');
            setNitError('');
            setDateError('');
            setAddressError('');
            setCountryError('');
            setCityError('');
            setEmailError('');
            setPhoneNumberError('');
            setContactDescriptionError('');
            setContactPhoneNumberError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.description?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.rif?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.nit?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.date?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.checkboxs?.isNational?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.address?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.selects?.countries?.id}`)?.attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.city?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.mail?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.phoneNumber?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.contactName?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.contactPhoneNumber?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            // $(`#${controls?.dataTables?.conceptsFind?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.conceptsFind?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <Modal backdrop='static' show={showModal} scrollable={false} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.supplier?.[languageObj?.id]}
                        src={images?.suppliersLogo}
                        style={styles?.cardHeaderLogo}></img> - {labels?.supplier?.[languageObj?.id]} ({processType === 0 ? labels?.add?.[languageObj?.id]?.toLowerCase() : (processType === 1 ? labels?.edit?.[languageObj?.id]?.toLowerCase() : labels?.details?.[languageObj?.id]?.toLowerCase())})
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>

            <form onSubmit={(e) => processType === 0 ?
                supplierAddPostAsync({ e: e, subMethod: 'form  onSubmit', }) :
                (processType === 1 ?
                    supplierEditPostAsync({ e: e, subMethod: 'form  onSubmit', })
                    : e?.preventDefault())}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => processType === 0 ? supplierAddPostAsync(e) : (processType === 1 ? supplierEditPostAsync(e) : e?.preventDefault())}> */}
                    {/* <div className='card card-primary card-outline shadow' > */}
                    {/* <div className='card-header'>
                            <h6 className='card-title'><img alt={labels?.supplier?.[languageObj?.id]} src={images?.suppliersLogo} style={styles?.cardHeaderLogo}></img> - {labels?.supplier?.[languageObj?.id]}</h6>
                        </div> */}

                    {/* <div className='card-body'> */}
                    {processType !== 2 ?
                        <div>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.description?.id}
                                                className={controls?.inputs?.description?.className}
                                                //autoFocus
                                                onChange={(e) => setSupplier({ ...supplier, description: e?.target?.value })}
                                                onFocus={() => setDescriptionError('')}
                                                placeholder={labels?.description?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.description?.[languageObj?.id]}
                                                value={supplier?.description || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.rif?.id}
                                                className={controls?.inputs?.rif?.className}
                                                onChange={(e) => setSupplier({ ...supplier, rif: e?.target?.value })}
                                                onFocus={() => setRifError('')}
                                                placeholder={labels?.rif?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.rif?.[languageObj?.id]}
                                                value={supplier?.rif || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.idCard} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(rifError)}</div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.nit?.id}
                                                className={controls?.inputs?.nit?.className}
                                                onChange={(e) => setSupplier({ ...supplier, nit: e?.target?.value })}
                                                onFocus={() => setNitError('')}
                                                placeholder={labels?.nit?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.nit?.[languageObj?.id]}
                                                value={supplier?.nit || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.idCard} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(nitError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    <div className='form-group'>
                                        {/* <DatePicker /> */}
                                        <div className='input-group mb-3'>
                                            <div className='input-group date' id={supplierDateId} data-target-input='nearest'>
                                                <input id={controls?.inputs?.date?.id}
                                                    className={controls?.inputs?.date?.className}
                                                    data-target={`#${supplierDateId}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setDateError('')}
                                                    placeholder={labels?.date?.[languageObj?.id]}
                                                    //tabIndex={-1}
                                                    tooltip='tooltip'
                                                    title={labels?.date?.[languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append' data-target={`#${supplierDateId}`} data-toggle='datetimepicker'>
                                                    <div className='input-group-text'><i className={globalSettings?.icons?.calendarAlt}></i></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div>
                                    </div>
                                </div>
                                <div className='col-6 text-muted'>
                                    <div className='form-group'>
                                        <div className='input-group'>
                                            <div className={controls?.checkboxs?.isNational?.className}>
                                                <input id={controls?.checkboxs?.isNational?.id}
                                                    //className={controls?.checkboxs?.isNational?.className}
                                                    onChange={(e) => setSupplier({ ...supplier, national: e?.target?.checked, })}
                                                    tooltip='tooltip'
                                                    title={labels?.isNational?.[languageObj?.id]}
                                                    checked={supplier?.national || false}
                                                    type='checkbox' />
                                                <label htmlFor={controls?.checkboxs?.isNational?.id}
                                                    tooltip='tooltip'
                                                    title={labels?.isNational?.[languageObj?.id]}>{labels?.isNational?.[languageObj?.id]}?
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <textarea id={controls?.inputs?.address?.id}
                                                className={controls?.inputs?.address?.className}
                                                onChange={(e) => setSupplier({ ...supplier, address: e?.target?.value, })}
                                                onFocus={() => setAddressError('')}
                                                placeholder={labels?.address?.[languageObj?.id]}
                                                rows={3}
                                                tooltip='tooltip'
                                                title={labels?.address?.[languageObj?.id]}
                                                value={supplier?.address || ''}>
                                            </textarea>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.mapMarker} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(addressError)}</div>
                                    </div>

                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.countries?.id}
                                                className={controls?.selects?.countries?.className}
                                                onChange={(e) => setSupplier({ ...supplier, countryId: e?.target?.value })}
                                                onFocus={() => setCountryError('')}
                                                placeholder={labels?.country?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.country?.[languageObj?.id]}
                                                defaultValue={supplier?.countryId || ''} >
                                                <option key='nothing'
                                                    value=''>{labels?.selectCountry?.[languageObj?.id]}
                                                </option>
                                                {countries?.map((country) => <option key={country?.id} value={country?.id}>{country?.description}</option>)}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-globe-americas' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(countryError)}</div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.city?.id}
                                                className={controls?.inputs?.city?.className}
                                                onChange={(e) => setSupplier({ ...supplier, city: e?.target?.value })}
                                                onFocus={() => setCityError('')}
                                                placeholder={labels?.city?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.city?.[languageObj?.id]}
                                                value={supplier?.city || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-map-marked-alt' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(cityError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.mail?.id}
                                                className={controls?.inputs?.mail?.className}
                                                onChange={(e) => setSupplier({ ...supplier, email: e?.target?.value })}
                                                onFocus={() => setEmailError('')}
                                                placeholder={labels?.email?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.email?.[languageObj?.id]}
                                                value={supplier?.email || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={globalSettings?.icons?.envelope} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(emailError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.phoneNumber?.id}
                                                className={controls?.inputs?.phoneNumber?.className}
                                                onChange={(e) => setSupplier({ ...supplier, phoneNumber: e?.target?.value })}
                                                onFocus={() => setPhoneNumberError('')}
                                                placeholder={labels?.phoneNumber?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.phoneNumber?.[languageObj?.id]}
                                                value={supplier?.phoneNumber || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-mobile-alt' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(phoneNumberError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-4'>
                                    {labels?.contact?.[languageObj?.id]}
                                </div>
                                <div className='col-8'>
                                    <hr />
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.contactName?.id}
                                                className={controls?.inputs?.contactName?.className}
                                                onChange={(e) => setSupplier({ ...supplier, contactDescription: e?.target?.value })}
                                                onFocus={() => setContactDescriptionError('')}
                                                placeholder={labels?.name?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.name?.[languageObj?.id]}
                                                value={supplier?.contactDescription || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-user-tie' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(contactDescriptionError)}</div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.contactPhoneNumber?.id}
                                                className={controls?.inputs?.contactPhoneNumber?.className}
                                                onChange={(e) => setSupplier({ ...supplier, contactPhoneNumber: e?.target?.value })}
                                                onFocus={() => setContactPhoneNumberError('')}
                                                placeholder={labels?.phoneNumber?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.phoneNumber?.[languageObj?.id]}
                                                value={supplier?.contactPhoneNumber || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className='fas fa-mobile-alt' />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(contactPhoneNumberError)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.description?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{supplier?.description || ''}</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.rif?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{supplier?.rif || ''}</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.nit?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{supplier?.nit || ''}</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.date?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        dateTimeFormatGlobalSet({
                                            date: supplier?.date || new Date(),
                                            type: languageObj?.format?.date?.f1,
                                            //format: languageObj?.format?.time?.type,
                                            format: 0,
                                            addTime: false,
                                            secondsShow: false,
                                            languageId: languageObj?.id,
                                            subMethod: currentMethod,
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.isNational?.[languageObj?.id]}?:
                                </div>
                                <div className='col-md-8'>
                                    <div className='icheck-primary d-inline'>
                                        <input checked={supplier?.national || false}
                                            readOnly
                                            tooltip='tooltip'
                                            title={labels?.isNational?.[languageObj?.id]}
                                            type='checkbox' />
                                        <label htmlFor={controls?.checkboxs?.isNational?.id} tooltip='tooltip'
                                            title={labels?.isNational?.[languageObj?.id]}></label>
                                    </div>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.address?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{supplier?.address || ''}</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.country?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{countries?.find(({ id, }) => id === supplier?.countryId || '')?.description || ''}</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.city?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{supplier?.city || ''}</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.email?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{supplier?.email || ''}</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.phone?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{supplier?.phoneNumber || ''}</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    <b>{labels?.contact?.[languageObj?.id]}</b>
                                </div>
                                <div className='col-md-8'>
                                    <hr />
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.name?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{supplier?.contactDescription || ''}</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.phone?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{supplier?.contactPhoneNumber || ''}</b>
                                </div>
                            </div>

                        </div>
                    }
                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning mx-1' hidden={processType === 2} tooltip='tooltip' title={labels?.save?.[languageObj?.id]} type='submit'><i className={globalSettings?.icons?.save}></i></button>
                                <button className='btn btn-outline-success' tooltip='tooltip' title={labels?.close?.[languageObj?.id]} type='reset' onClick={() => defaultValueSetAsync(true)}><i className={globalSettings?.icons?.arrowCircleLeft}></i></button>
                            </div>
                        </div> */}
                    {/* </div> */}
                    {/* </form> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}